import React, { useState, useContext } from 'react'
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom"
import { AppStateContext } from '../AppStateContext';

import { translations } from '../data/treatment'
import { useNavigate } from 'react-router-dom';

import Whatsapp from '../media/WhatsApp.svg'

// IMPORT COMPONENT
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'


// IMPORT BUTTON
import PrimaryButton from '../components/button/PrimaryButton';
import SecondButton from '../components/button/SecondButton';


const Treatment = () => {
    const { name } = useParams();
    const navigate = useNavigate();
    const { language } = useContext(AppStateContext);

    // Dil ve tedavi verilerini al
    const translation = translations[language];
    const treatment = translation[name];

    // Page Title
    const pageTitle = treatment.name
    const metaDescription = treatment.title1

    // Eğer dil veya tedavi bulunamazsa hata mesajı göster
    if (!translation || !treatment) {
        return <div>Error: Language or Treatment not found.</div>;
    }

    const openLink = (url) => {
        window.open(
            url,
            '_blank'
        );
    }

    const handleNavigation = (path) => {
        window.scrollTo(0, 0);
        navigate(path);
    }

    return (
        <div>
            <Helmet>
                <title> {pageTitle} | DT. Yesim Alkan </title>
                <meta name="description" content={metaDescription} />
                <link rel="canonical" href="http://dtyesimalkan.com/treatment" />
            </Helmet>

            <Navbar />
            <div className='mt-[120px]'></div>
            <div style={{ fontFamily: 'Righteous' }} className='py-5 md:py-10 md:pb-20 px-5 text-2xl md:text-4xl text-[#0F969C] md:text-center font-bold'>{treatment.name}</div>
            <div className='flex flex-col gap-10 max-w-screen-xl m-auto px-5 pb-10'>
                <div className='flex flex-col md:flex-row gap-10'>
                    <div className='w-full md:w-1/2 m-auto flex flex-col gap-5'>
                        <div className='text-xl md:text-2xl font-bold'>{treatment.title1}</div>
                        <div className='md:text-lg'>{treatment.description} </div>
                        <div className='md:text-lg'>{treatment.paragraph1}</div>
                    </div>
                    <img src={treatment.images[0]} className='w-full md:w-1/2 object-cover h-[300px] md:h-[400px] rounded-xl'></img>
                </div>
                <div className='flex flex-col md:flex-row-reverse gap-10'>
                    <div className='w-full md:w-1/2 m-auto flex flex-col gap-5'>
                        <div className='text-xl md:text-2xl font-bold'>{treatment.title2}</div>
                        <div className='md:text-lg'>{treatment.paragraph2}</div>
                    </div>
                    <img src={treatment.images[1]} className='w-full md:w-1/2 object-cover h-[300px] md:h-[400px] rounded-xl'></img>
                </div>
                <div className='flex flex-col md:flex-row gap-10'>
                    <div className='w-full md:w-1/2 m-auto flex flex-col gap-5'>
                        <div className='text-xl md:text-2xl font-bold'>{treatment.title3}</div>
                        <div className='md:text-lg'>{treatment.paragraph3}</div>
                    </div>
                    <img src={treatment.images[2]} className='w-full md:w-1/2 object-cover h-[300px] md:h-[400px] rounded-xl'></img>

                </div>
                <div className='flex flex-row gap-5 pt-5 justify-start'>
                    <a href='/treatments'>
                        <SecondButton className={'hidden md:block'} text={'Tedaviler'} />
                    </a>
                    <a href='/contact'>
                        <SecondButton className={'hidden md:block'} text={'Bizimle İletişime Geçin'} />
                    </a>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default Treatment